<div class="container" [ngStyle]="{ gap: emptyInfos.smallGap ? 'var(--space-s)' : 'var(--space-l)' }">
    <div [class.circledGreen]="emptyInfos.circledGreen">
        <img
            [ngStyle]="{
                'font-size': emptyInfos.iconSize ? emptyInfos.iconSize + 'rem' : '10rem',
                height: emptyInfos.iconHeight ? emptyInfos.iconHeight + 'rem' : 'unset',
                margin: emptyInfos.imgMargin,
            }"
            [src]="'assets/icon/' + emptyInfos.img"
        />
    </div>
    <div>
        <div class="headline-bold">
            <div *ngIf="emptyInfos.title">{{ emptyInfos.title }}</div>
            <ng-content select="[title]"></ng-content>
        </div>
        <div *ngIf="emptyInfos.subtitle" class="sub-headline-bold grey">{{ emptyInfos.subtitle }}</div>
        <div *ngIf="emptyInfos.subtitle2" class="sub-headline-bold grey">{{ emptyInfos.subtitle2 }}</div>
    </div>
    <ng-content select="[center]"></ng-content>
    <div class="body-medium yellow">{{ emptyInfos.text }}</div>
    <ng-content select="[end]"></ng-content>
</div>
